export var ArrowStyleType;
(function (ArrowStyleType) {
    ArrowStyleType[ArrowStyleType["CommonLeft"] = 0] = "CommonLeft";
    ArrowStyleType[ArrowStyleType["CommonRight"] = 1] = "CommonRight";
    ArrowStyleType[ArrowStyleType["CommonBoth"] = 2] = "CommonBoth";
    ArrowStyleType[ArrowStyleType["SolidLeft"] = 3] = "SolidLeft";
    ArrowStyleType[ArrowStyleType["SolidRight"] = 4] = "SolidRight";
    ArrowStyleType[ArrowStyleType["SolidBoth"] = 5] = "SolidBoth";
})(ArrowStyleType || (ArrowStyleType = {}));
